import { Input, Space } from 'antd'
import React, { memo, useState, useEffect, useCallback } from 'react'
import styles from '../../index.module.less'
import { LayoutEnum } from '../../enum'

const Index = (props: any) => {
  const { field, onChange, value } = props
  const { width, label, layout, allowClear } = field
  const triggerChange = v => {
    onChange?.(v)
  }
  const handleInputValueChange = e => {
    triggerChange(e.target.value)
  }
  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          <div className={styles.addon}>{label}</div>
          <Input
            value={value}
            onChange={handleInputValueChange}
            style={{ width }}
            placeholder={`请输入${label}`}
            allowClear
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          <div className={styles.addon}>{label}</div>
          <Input
            value={value}
            onChange={handleInputValueChange}
            style={{ width }}
            placeholder={`请输入${label}`}
            allowClear
          />
        </div>
      )}
    </div>
  )
}

export default Index
